"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CalculatorContext = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _CalculatorPlanSelectorTile = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/CalculatorPlanSelectorTile"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _middleBlob = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/middle-blob.svg"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _SpinnerLoadWrapper = _interopRequireDefault(require("../../components/loading/SpinnerLoadWrapper"));

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _Terms = require("self-service-api/constants/Terms");

var _AnnualDiscountLegalDisclaimer = _interopRequireDefault(require("./AnnualDiscountLegalDisclaimer"));

var _CalcCovidPromoBannerContainer = _interopRequireDefault(require("./CalcCovidPromoBannerContainer"));

var _stateUtils = require("../../utils/stateUtils");

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 85%;\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    height: auto;\n    min-height: 360px;\n    flex-direction: column;\n    padding-bottom: 50px;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 330px;\n  min-height: 490px;\n  color: ", ";\n  text-align: center;\n  padding: 35px 30px;\n  ", ";\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  align-items: flex-start;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: -webkit-sticky;\n  position: sticky;\n  top: 15%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n    padding-top: 0;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 330px;\n  text-align: center;\n  padding: 20px 15px 0 15px;\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  margin-bottom: 40px;\n  margin-top: 40px;\n  max-width: 1280px;\n  margin: 0 auto;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  margin-top: -24px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  z-index: 1;\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n  padding-top: 68px;\n  padding-bottom: 12px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CalculatorContext = _react.default.createContext(null);

exports.CalculatorContext = CalculatorContext;

var Title = _styledComponents.default.h1.withConfig({
  displayName: "Calculator__Title",
  componentId: "tu7enz-0"
})(_templateObject());

var StyledContent = _styledComponents.default.div.withConfig({
  displayName: "Calculator__StyledContent",
  componentId: "tu7enz-1"
})(_templateObject2());

var StyledImageBackground = (0, _styledComponents.default)(_UIImage.default).withConfig({
  displayName: "Calculator__StyledImageBackground",
  componentId: "tu7enz-2"
})(_templateObject3());

var CalculatorWrapper = _styledComponents.default.div.withConfig({
  displayName: "Calculator__CalculatorWrapper",
  componentId: "tu7enz-3"
})(_templateObject4());

var Footer = _styledComponents.default.div.withConfig({
  displayName: "Calculator__Footer",
  componentId: "tu7enz-4"
})(_templateObject5(), _responsiveBreakpoints.default.tablet(_templateObject6()));

var ResponsiveUIFlex = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "Calculator__ResponsiveUIFlex",
  componentId: "tu7enz-5"
})(_templateObject7(), _responsiveBreakpoints.default.tablet(_templateObject8()));

var StickyContainer = _styledComponents.default.div.withConfig({
  displayName: "Calculator__StickyContainer",
  componentId: "tu7enz-6"
})(_templateObject9());

var PriceDisplayContainer = _styledComponents.default.div.withConfig({
  displayName: "Calculator__PriceDisplayContainer",
  componentId: "tu7enz-7"
})(_templateObject10());

var StyledTile = (0, _styledComponents.default)(_UITile.default).withConfig({
  displayName: "Calculator__StyledTile",
  componentId: "tu7enz-8"
})(_templateObject11(), _colors.OLAF, _responsiveBreakpoints.default.tablet(_templateObject12()), _responsiveBreakpoints.default.phoneLarge(_templateObject13()));

var Calculator = function Calculator(_ref) {
  var PlanSelectorComponent = _ref.PlanSelectorComponent,
      PriceDisplayComponent = _ref.PriceDisplayComponent,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded,
      isCovidGrowthSuitePromoEligible = _ref.isCovidGrowthSuitePromoEligible;

  var _useActiveTerm = (0, _stateUtils.useActiveTerm)(),
      activeTerm = _useActiveTerm.activeTerm;

  var _useContext = (0, _react.useContext)(CalculatorContext),
      state = _useContext.state;

  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var activeEdition = state.edition;
  return _react.default.createElement(CalculatorWrapper, null, _react.default.createElement(StyledImageBackground, {
    src: _middleBlob.default
  }), _react.default.createElement(StyledContent, null, _react.default.createElement(Title, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.title"
  })), _react.default.createElement(_CalcCovidPromoBannerContainer.default, {
    isCovidGrowthSuitePromoEligible: isCovidGrowthSuitePromoEligible
  }), _react.default.createElement(ResponsiveUIFlex, {
    direction: "row",
    justify: "center",
    align: "stretch"
  }, _react.default.createElement("div", null, _react.default.createElement(_CalculatorPlanSelectorTile.default, null, _react.default.createElement(_SpinnerLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded
  }, _react.default.createElement(PlanSelectorComponent, null)))), _react.default.createElement(PriceDisplayContainer, null, _react.default.createElement(StickyContainer, null, _react.default.createElement(StyledTile, {
    className: "tile-gradient-backdrop"
  }, _react.default.createElement(_SpinnerLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    use: "on-dark"
  }, _react.default.createElement(PriceDisplayComponent, null))), _react.default.createElement(Footer, null, _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: isInMCBeta ? 'pricingPage.feeIncreasesProductServicesCatalogMC' : 'pricingPage.feeIncreasesProductServicesCatalog'
  }), activeTerm === _Terms.ANNUAL && _react.default.createElement(_react.Fragment, null, _react.default.createElement("br", null), _react.default.createElement(_AnnualDiscountLegalDisclaimer.default, {
    activeEdition: activeEdition
  })))))))));
};

Calculator.propTypes = {
  PlanSelectorComponent: _propTypes.default.elementType.isRequired,
  PriceDisplayComponent: _propTypes.default.elementType.isRequired,
  hasPricingAndPurchasingSucceeded: _propTypes.default.bool.isRequired,
  isCovidGrowthSuitePromoEligible: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Calculator);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/Calculator.js
// module id = 123
// module chunks = 5 6